var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as routables from '@idp/routables';
import { RoutableContainer } from '@idp/routables';
import * as React from 'react';
import * as Loadable from 'react-loadable';
import { CMS } from '@idp/cms-integration';
import { CatalogDataType, RouteUrlTypes, SentryTeam, } from './MainView.container.props';
import MainViewState from './MainView.container.state';
import * as styles from './MainView.container.scss';
import { offersService } from '../../services/Offers.service';
import { DialogService, CustomErrMsgDialog } from '@idp/ui-components';
import { withStore } from '@idp/state-manager';
import { StateProvider } from '../../services/state-provider';
import { isMobile, getIDSEIntent, getQueryParamValue, cookieToObj, isEmptyObject, getUrlParamValue, isIxpFeatureEnabled, getProfileInfo, isEmpty, updateDetails, getCookie } from '../../utils/UtilityFunctions';
import { ThemeColor } from '@idp/ui-components/components/panels/Feedback/FeedbackProps';
import { checkAndSetZipCode } from '../../services/zip-code-provider';
import { ICCEventBusManager } from '@idp/event-bus';
import { CatalogErrorMsgCms } from './CatalogErrorMsg.cms';
import { apiCTOModalMsgCms, CTOErrorCodes } from './apiCTOModal.cms';
import { isNullOrUndefined } from 'util';
import { CMSFeedMap, nameMap, titleMap, loadedPanelURL } from './MainViewMaps';
import LoginOrchestration from '../LoginOrchestration/LoginOrchestration';
import Utilities from '@idse/wireless-ui/api/Utilities';
// Persistence Cart
import InitializeCart from '@idp/cart-initializer/CartInit';
import InfiniteLoader from '@idp/ui-components/components/atoms/InfiniteLoader/InfiniteLoaderDesktop';
import SessionTimerModal from '../SessionTimerModal';
import { logToSplunk, logToSplunkwithExtraDetails } from '../../services/logService';
import { FeatureState } from '@idp/business-features/FeatureState/feature-state';
import HalocAuthenticationService from '@idp/login-ui/services/HalocAuthenticationService';
// importing Sentry.IO
import * as Sentry from '@sentry/browser';
import BannerContainer from '../BannerContainer/BannerContainer';
import { LinkPositionDataKeysOptions, EventActions } from '../../services/AnalyticsEvents';
import ReportingGateway from '../../services/ReportingGateway';
var baseURLOverall = '/msapi/offers/v1';
var baseURLDTVNOW = '/msapi/salesproductorchestration/v1/baseOffers';
var iptvMigration = '&iptvMigration=true';
var iptvMigrationIntent = '&iptvMigrationIntent=';
var baseURLWireless = '/msapi/salesproductorchestration/v1/wireless?lobs=wireless&losgTypes=NEW&productTypes=device,sharedDataGroup,dataPlan&mode=buyflow&offerTypes=standalone&deviceOffset=0&deviceLimit=50&paymentType=postpaid';
var baseURLWirelessPrepaid = '/msapi/salesproductorchestration/v1/wireless?lobs=wireless&losgTypes=NEW&productTypes=sharedDataGroup,device&mode=buyflow&paymentType=prepaid';
var baseURLWirelessAL = '/msapi/salesproductorchestration/v1/wireless?lobs=wireless&losgTypes=AL&productTypes=device,sharedDataGroup&mode=buyflow&offerTypes=standalone&deviceOffset=0&deviceLimit=50&paymentType=postpaid';
var baseURLWirelessALHylaToggle = '/msapi/salesproductorchestration/v1/wireless?lobs=wireless&losgTypes=AL&productTypes=device,sharedDataGroup&mode=buyflow&offerTypes=standalone,tradein&deviceOffset=0&deviceLimit=50&paymentType=postpaid';
var priceInfoUrl = 'msapi/cart/v1/priceInfo';
var createSalesSessionAPI = '/msapi/referrals/v1/sessionKeepAlive';
var sentryErrorMsg = 'Sentry not Initialized! Error:';
var Wireless = Loadable({
    loader: function () { return import(/* webpackChunkName: 'Wireless' */ '@idse/wireless-ui/components/WirelessConsole'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var Broadband = Loadable({
    loader: function () { return import(/* webpackChunkName: 'Broadband' */ '@idse/bundle-ui/components/Bundle'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var Bundle = Loadable({
    loader: function () { return import(/* webpackChunkName: 'bundle' */ '@idse/bundle-ui/components/Bundle'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var MainViewContainer = /** @class */ (function (_super) {
    __extends(MainViewContainer, _super);
    function MainViewContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.cmsErrorCodes = [{
                apiName: '',
                errorCode: '',
                errorMsg: '',
                httpCode: 0,
            }];
        _this.pageLoadEventTriggered = false;
        _this.displayHardStopPage = false;
        _this.observerId = '';
        _this.upperFunnelDetailsSentToIDP = 'upperFunnelDetailsSentToIDP';
        _this.banKey = 'inFocusWirelessBAN';
        _this.ctnKey = 'selectedCTNforUpgrade';
        _this.loopCounter = 0;
        _this.featureConfigObj = {
            featureAPIUri: '/msapi/ixp-allocation-manager-service/v1/allocations',
            targetPath: '/msapi',
            teams: 'bcv,pcv1,pcv2,pcv3,offers,catalog,checkoutms,pands',
            userId: 'user-001',
        };
        _this.validateStoredIntent = function (storedIntent, wlsIntent) {
            return (storedIntent === null || storedIntent === void 0 ? void 0 : storedIntent.toUpperCase()) === wlsIntent.toUpperCase();
        };
        _this.isLob = function (lobName) {
            var baseURL = (_this.stateManager.get('appShell', 'baseURL') || { url: location.href });
            return (baseURL && baseURL.url && baseURL.url.toLowerCase().search(lobName) > -1);
        };
        _this.state = new MainViewState();
        _this.apiCTOModalCmsData = new apiCTOModalMsgCms();
        _this.initSentry = _this.initSentry.bind(_this);
        _this.setSentryTeam = _this.setSentryTeam.bind(_this);
        _this.handleOKButton = _this.handleOKButton.bind(_this);
        _this.handleCancelButton = _this.handleCancelButton.bind(_this);
        _this.dialog = DialogService.getInstance();
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.crpChangeListener = _this.crpChangeListener.bind(_this);
        _this.iptvListener = _this.iptvListener.bind(_this);
        _this.getCmsRoute = _this.getCmsRoute.bind(_this);
        _this.loadWirelessOffers = _this.loadWirelessOffers.bind(_this);
        _this.LoginOrchestrationCallBack = _this.LoginOrchestrationCallBack.bind(_this);
        _this.setURLInState = _this.setURLInState.bind(_this);
        _this.getAppData = _this.getAppData.bind(_this);
        _this.firePageLoadEvent = _this.firePageLoadEvent.bind(_this);
        _this.initializeCart = _this.initializeCart.bind(_this);
        _this.loadLOBConsole = _this.loadLOBConsole.bind(_this);
        _this.redirectToZippyFlow = _this.redirectToZippyFlow.bind(_this);
        _this.callSessionCreationAPI = _this.callSessionCreationAPI.bind(_this);
        _this.processAuthResponse = _this.processAuthResponse.bind(_this);
        _this.getRedirectURL = _this.getRedirectURL.bind(_this);
        _this.initQueueIt = _this.initQueueIt.bind(_this);
        _this.featureToggleSwitcher = _this.featureToggleSwitcher.bind(_this);
        _this.findEapState = _this.findEapState.bind(_this);
        _this.pageLoadForErrorModal = _this.pageLoadForErrorModal.bind(_this);
        _this.loadSessionTimerPing = _this.loadSessionTimerPing.bind(_this);
        _this.redirectToPDPFlow = _this.redirectToPDPFlow.bind(_this);
        _this.fixUrl = _this.fixUrl.bind(_this);
        return _this;
    }
    MainViewContainer.getDerivedStateFromError = function () {
        var error = __assign({ apiName: '', errorCode: '' }, CatalogErrorMsgCms.content.errorDefaultMsg);
        return { error: error };
    };
    // SENTRY IO Additions ////////////////////////////////////////////////////////////////////////
    // determines if in prod or non-prod environment
    MainViewContainer.prototype.isProd = function () {
        var termMap = ['tst', 'dev', 'finalstage', 'stage', 'bpe', 'localhost'].map(function (term) {
            return location.host.includes(term);
        });
        return !(termMap.includes(true));
    };
    // sets the dsn to point to sentry hosted on the nearest data center
    MainViewContainer.prototype.setSentryServer = function (dataCenter) {
        var _this = this;
        var _a;
        Sentry.init({
            beforeSend: function (event) {
                _this.extractCookieData();
                return event;
            },
            dsn: (_a = process.env) === null || _a === void 0 ? void 0 : _a['sentry_' + (dataCenter || 'non_prod')],
        });
    };
    // look into the cookies to find idse_stack, which is the closest
    // available data center for sentry.
    MainViewContainer.prototype.findDataCenter = function () {
        var cookies = document === null || document === void 0 ? void 0 : document.cookie;
        var cookiesArray = (cookies !== null) ? cookies.split(' ') : null;
        if (cookiesArray) {
            var dataCenter = cookiesArray.find(function (term) {
                return term.indexOf('idse_stack') !== -1;
            });
            if (dataCenter) {
                return dataCenter
                    .split('=')[1]
                    .slice(0, 4);
            }
            else {
                return 'dadc';
            }
        }
        else {
            return 'dadc';
        }
    };
    // initializes Sentry
    MainViewContainer.prototype.initSentry = function () {
        var _this = this;
        if (this.isProd()) {
            // use sentry prod server in production
            try {
                this.setSentryServer(this.findDataCenter());
            }
            catch (e) {
                console.error(sentryErrorMsg + e);
                logToSplunkwithExtraDetails(sentryErrorMsg + e, { url: 'Core-ui:initSentry', apiName: 'IDP_LOG initSentry failed in prod' });
            }
        }
        else {
            // use sentry dev server for all other environments
            try {
                // prevent sentry from throwing an error if incorrect dsn is given, which could stop page loading in IE
                Sentry.init({
                    beforeSend: function (event) {
                        _this.extractCookieData();
                        return event;
                    },
                    dsn: process.env.sentry_non_prod,
                });
                this.setSentryTeam(SentryTeam.PLATFORM_UI);
            }
            catch (e) {
                console.error(sentryErrorMsg + e);
                logToSplunkwithExtraDetails(sentryErrorMsg + e, { url: 'Core-ui:initSentry', apiName: 'IDP_LOG initSentry failed in dev' });
            }
        }
    };
    // extracts required cookie data to send to Sentry
    MainViewContainer.prototype.extractCookieData = function () {
        var cookieData = cookieToObj(document.cookie);
        Sentry.configureScope(function (scope) {
            scope.setTag('data_center', cookieData.idse_stack || 'NA');
            scope.setTag('browser_id', cookieData.browserid || 'NA');
            scope.setTag('sales_session_id', cookieData.IDPSALESSESSIONID || 'NA');
            scope.setTag('shop_session_id', cookieData.IDPSHOPSESSIONID || 'NA');
            scope.setTag('tltsid', cookieData.TLTSID || 'NA');
        });
    };
    // creates tag for setting the sentry team
    MainViewContainer.prototype.setSentryTeam = function (team) {
        Sentry.configureScope(function (scope) {
            scope.setTag('team', team);
        });
    };
    // END Sentry IO Additions ////////////////////////////////////////////////////////////////////////
    MainViewContainer.prototype.getDtvsPersonalzationParamter = function (lob, bundleType) {
        var _this = this;
        // tslint:disable-next-line:no-any
        var dataToPersonalizeDtvs = this.stateManager.get(lob, 'P13N');
        var topPanelCmsFeed = CMSFeedMap.get(bundleType) ? CMSFeedMap.get(bundleType) : CMSFeedMap.get(CatalogDataType.DTVNOW);
        this.state.reRenderOnPersonlization = true;
        // tslint:disable-next-line:no-any
        var cmsPageObjectDtvs = {
            dtvsPromoType: dataToPersonalizeDtvs.topPanel,
            pageName: 'dtv',
            referrerUrl: document.referrer,
        };
        var appshellRouteCallData = CMS.route(this, cmsPageObjectDtvs, topPanelCmsFeed, true, this.stateManager, true);
        appshellRouteCallData.then(function () {
            _this.setState({ allowCMSGetCall: true });
        });
    };
    // CMS ROUTE MAPPING FOR TOP PANEL DEPENDING ON THE CATALOG DATA TYPE
    MainViewContainer.prototype.getCmsRoute = function (bundleType) {
        console.log('calling getCmsRoute function.....');
        if (!this.state.allowCMSGetCall && !this.state.reRenderOnPersonlization) {
            var topPanelCmsFeed = CMSFeedMap.get(bundleType) ? CMSFeedMap.get(bundleType) : CMSFeedMap.get(CatalogDataType.DTVNOW);
            var topPanelCmsPageName = nameMap.get(bundleType) ? nameMap.get(bundleType) : nameMap.get(CatalogDataType.DTVNOW);
            var cmsVersion = '';
            // tslint:disable-next-line:no-any
            var cmsPageObject = {
                cmsversion: cmsVersion,
                defaultIntent: 'bundles',
                pageName: topPanelCmsPageName,
                referrerUrl: document.referrer,
                wirelessType: this.state.prepaidFlow ? 'prepaid' : '',
            };
            var appshellRouteCallData = CMS.route(this, cmsPageObject, topPanelCmsFeed, true, this.stateManager);
            return appshellRouteCallData;
        }
    };
    /**
     * @description Fix URL based on queryparameter
     * @param queryString string
     * @returns string
     */
    MainViewContainer.prototype.fixUrl = function (queryString) {
        if (isEmpty(queryString)) {
            return '';
        }
        return "/?" + queryString;
    };
    MainViewContainer.prototype.loadDtvNowOffers = function () {
        var _this = this;
        var dtvNowUrl = baseURLDTVNOW;
        if (location.href.indexOf('&iptvMigration=true') > -1) {
            dtvNowUrl += iptvMigration;
        }
        var iptvObj = this.stateManager.get('DTVNOW', 'iptvMigrationIntent');
        if (iptvObj !== null && iptvObj !== undefined) {
            dtvNowUrl = dtvNowUrl + iptvMigrationIntent + (iptvObj.intent) ? 'true' : 'false';
        }
        return offersService.fetchData(dtvNowUrl, CatalogDataType.DTVNOW).then(function (data) {
            var errorObj = _this.catalogErrorHandling(data);
            if (errorObj.isError) {
                _this.actionOnError(errorObj);
            }
            else {
                _this.stateManager.set('catalogResponse', data);
            }
            _this.setState({ loading: false });
        });
    };
    MainViewContainer.prototype.isHardStopPageRequired = function (flowtype) {
        var wirelessDetails = this.stateManager.get('appShell', 'wirelessDetails');
        var isEapOnDevice = ((wirelessDetails === null || wirelessDetails === void 0 ? void 0 : wirelessDetails.experienceType) === 'onDevice') && !isIxpFeatureEnabled('svc-pcv1-eap-on-device-aal');
        return (flowtype === 'new' && isEapOnDevice);
    };
    /**
     * @function redirectToPDPFlow
     * @description Redirects to a PDP flow if IXP flag is turned on.
     * @returns void
     */
    MainViewContainer.prototype.redirectToPDPFlow = function () {
        var getUrl = window.location;
        var queryString = getUrl.search.slice(1);
        var redirectUrl = getUrl.protocol + '//' + getUrl.host + '/buy/postpaid' + this.fixUrl(queryString);
        if (redirectUrl) {
            window.location.replace(redirectUrl);
        }
    };
    MainViewContainer.prototype.loadWirelessOffers = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var baseURL, wlsIntent_1, ppoIntent, authRedirectUrlSession, qparam, storedSessionIntent, customerType, wirelessoffersURL_1, flowtype, wlsAuthDetails, wirelessAuthUrl, withExtraParams, upperFunnelDetails;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Invoke QueueIt if enabled
                        this.featureToggleSwitcher();
                        return [4 /*yield*/, this.initQueueIt()];
                    case 1:
                        _b.sent();
                        baseURL = this.stateManager.get('appShell', 'baseURL');
                        if (!baseURL) {
                            baseURL = { url: location.href };
                            this.setURLInState();
                        }
                        if (baseURL) {
                            wlsIntent_1 = getIDSEIntent();
                            // setting wirelessExperience based on wireless lob navigation from upperfunnel.
                            baseURL.url = baseURL.url.toLowerCase();
                            ppoIntent = getQueryParamValue && getQueryParamValue('ppo');
                            if (ppoIntent) {
                                this.stateManager.set('ppo', { ppo: ppoIntent });
                            }
                            authRedirectUrlSession = sessionStorage.getItem('Wireless:AuthRedirectUrl') || '';
                            qparam = new URL(window.location.href).search;
                            storedSessionIntent = new URLSearchParams(authRedirectUrlSession);
                            if (!authRedirectUrlSession || !this.validateStoredIntent(storedSessionIntent.get('wlsfi'), wlsIntent_1)) {
                                sessionStorage.setItem('Wireless:AuthRedirectUrl', qparam);
                            }
                            customerType = getCookie('DTAB');
                            this.setWirelessExperience(baseURL.url);
                            wirelessoffersURL_1 = '';
                            flowtype = void 0;
                            if (baseURL.url.indexOf('/prepaid') > -1) {
                                this.state.prepaidFlow = true;
                                wirelessoffersURL_1 = baseURLWirelessPrepaid;
                            }
                            else if (wlsIntent_1.search('al|aal|alf') > -1) {
                                wirelessoffersURL_1 = Utilities.isAccountEligibleForHylaTradeInApi() ? baseURLWirelessALHylaToggle : baseURLWirelessAL;
                                flowtype = 'aal';
                            }
                            else {
                                wirelessoffersURL_1 = baseURLWireless;
                                flowtype = 'new';
                            }
                            if (isIxpFeatureEnabled('svc-redirection-to-postpaid') &&
                                wlsIntent_1 === 'up' &&
                                customerType === null) {
                                this.redirectToPDPFlow();
                            }
                            if (this.isHardStopPageRequired(flowtype)) {
                                this.setState({ loading: false, canLoadLobConsole: true });
                                return [2 /*return*/, Promise.resolve(this)];
                            }
                            getProfileInfo().then(function (data) {
                                if (data && !data.error && !data.details && data.content) {
                                    _this.stateManager.set('customerProfileInfo', data);
                                }
                                else {
                                    _this.stateManager.remove('customerProfileInfo');
                                }
                            }).catch(function (res) {
                                _this.stateManager.remove('customerProfileInfo');
                            });
                            wlsAuthDetails = this.stateManager.get('appShell', 'wlsAuthDetails');
                            // If wlsintent is upgrade flow and wlsauthdetails is holding AAL session then remove and make auth call for upgrade
                            if (wlsIntent_1 === 'up' && wlsAuthDetails && !wlsAuthDetails.hasOwnProperty('upgradeEligibilityInfo')) {
                                this.stateManager.remove('wlsAuthDetails');
                            }
                            if ((wlsIntent_1.search('al|aal|alf|up') > -1) && !wlsAuthDetails) {
                                wirelessAuthUrl = '/msapi/wirelessorder/v1/auth/';
                                withExtraParams = (_a = sessionStorage.getItem('Wireless:AuthRedirectUrl')) === null || _a === void 0 ? void 0 : _a.trim();
                                if (wlsIntent_1 === 'up') {
                                    wirelessAuthUrl = wirelessAuthUrl + ("upgrade" + (withExtraParams ? withExtraParams : '?wlsfi=UP'));
                                    upperFunnelDetails = this.stateManager.get('appShell', this.upperFunnelDetailsSentToIDP);
                                    if (upperFunnelDetails &&
                                        Object.keys(upperFunnelDetails).filter(function (e) { return e === _this.banKey || e === _this.ctnKey; }).length > 1) {
                                        wirelessAuthUrl = wirelessAuthUrl + '&' + this.banKey + '=' + upperFunnelDetails[this.banKey];
                                        wirelessAuthUrl = wirelessAuthUrl + '&' + this.ctnKey + '=' + upperFunnelDetails[this.ctnKey];
                                    }
                                }
                                if (wlsIntent_1.search('al|aal|alf') > -1) {
                                    wirelessAuthUrl = wirelessAuthUrl + "addaline" + (withExtraParams ? withExtraParams : '?wlsfi=AL');
                                }
                                return [2 /*return*/, offersService.fetchData(wirelessAuthUrl).then(function (data) {
                                        return _this.processAuthResponse(wirelessoffersURL_1, wlsIntent_1, data);
                                    }).catch(function (res) {
                                        var _a;
                                        return (_a = res === null || res === void 0 ? void 0 : res.clone()) === null || _a === void 0 ? void 0 : _a.json().then(function (err) {
                                            console.log("loadWirelessOffers auth err", res, err, err === null || err === void 0 ? void 0 : err.error);
                                            _this.stateManager.remove('wlsAuthDetails');
                                            _this.stateManager.remove('IDSEIntent');
                                            _this.setState({ loading: false });
                                            return Promise.reject(err);
                                        });
                                    })];
                            }
                            else {
                                if (wlsIntent_1 === 'up') {
                                    // this is the page reload scenario for the wireless upgrade flow
                                    this.setState({ loading: false, canLoadLobConsole: true });
                                    return [2 /*return*/, Promise.resolve(this)];
                                }
                                else if (wlsIntent_1 && (wlsIntent_1.search('al|aal|alf') > -1)) {
                                    checkAndSetZipCode();
                                    wirelessoffersURL_1 = this.constructdeiveListUrlwithAuthDetails(wirelessoffersURL_1);
                                    return [2 /*return*/, this.prepareWirelessOffers(wirelessoffersURL_1)];
                                }
                                else {
                                    checkAndSetZipCode();
                                    return [2 /*return*/, this.prepareWirelessOffers(wirelessoffersURL_1)];
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MainViewContainer.prototype.prepareWirelessOffers = function (url) {
        var _this = this;
        return offersService.fetchData(url, CatalogDataType.Wireless).then(function (data) {
            if (!isEmptyObject(data)) {
                var errorObj = _this.catalogErrorHandling(data);
                if (errorObj && errorObj.isError) {
                    _this.actionOnError(errorObj);
                }
                else {
                    _this.stateManager.set('catalogResponse', data);
                }
                _this.setState({ loading: false, canLoadLobConsole: true });
            }
        });
    };
    MainViewContainer.prototype.constructdeiveListUrlwithAuthDetails = function (url) {
        var _a;
        var authDetails = this.stateManager.get('appShell', 'wlsAuthDetails');
        var shareDataCode = '';
        var psocCode = '';
        if ((_a = authDetails === null || authDetails === void 0 ? void 0 : authDetails.accountDetails) === null || _a === void 0 ? void 0 : _a.planGroups) {
            var planGroups = authDetails.accountDetails.planGroups;
            if (planGroups) {
                for (var _i = 0, planGroups_1 = planGroups; _i < planGroups_1.length; _i++) {
                    var planGroup = planGroups_1[_i];
                    if (planGroup && planGroup.subscribers && planGroup.subscribers.length > 0) {
                        for (var _b = 0, _c = planGroup.subscribers; _b < _c.length; _b++) {
                            var subscrieber = _c[_b];
                            var shareDtCode = subscrieber.sharedDataGroupSocCode;
                            var planCode = subscrieber.planSocCode;
                            shareDataCode = !shareDataCode ? shareDtCode : shareDataCode + ',' + shareDtCode;
                            psocCode = !psocCode ? planCode : psocCode + ',' + planCode;
                            break;
                        }
                    }
                }
            }
        }
        if (authDetails === null || authDetails === void 0 ? void 0 : authDetails.planItemBean) {
            var planItem = authDetails.planItemBean;
            if (isEmpty(shareDataCode)) {
                shareDataCode = planItem.sharedDataGroupSocCode ? planItem.sharedDataGroupSocCode : '';
            }
            if (isEmpty(psocCode)) {
                psocCode = planItem.singleUserCode ? planItem.singleUserCode : planItem.planSocCode;
            }
        }
        if (psocCode) {
            url = url + '&ratePlanSoc=' + psocCode;
        }
        if (shareDataCode) {
            url = url + '&sdgSoc=' + shareDataCode;
        }
        if (authDetails && authDetails.stcFlow) {
            url = url + '&source=cpop';
        }
        return url;
    };
    MainViewContainer.prototype.setWirelessExperience = function (url) {
        if (url && url.indexOf(RouteUrlTypes.WIRELESS) > -1) {
            var wirelessDetails = { wirelessType: 'postpaid', experienceType: 'devicesfirst' };
            if (url.includes('/prepaid')) {
                wirelessDetails.wirelessType = 'prepaid';
                wirelessDetails.experienceType = 'byod';
            }
            var queryParam = url.split('?')[1];
            /**
             * Added by Abhishek Dhanda (AD5575)
             * To handle page refresh scneario, checking if we already have experience type in state manager then use that one.
             * (e.g. user started with plan first flow and scrolled the page, now on refresh user moving to device first flow).
             */
            var wirelessDetailsInSM = this.stateManager.get('appShell', 'wirelessDetails');
            if (queryParam) {
                var paramArry = queryParam.split('&');
                if (paramArry.includes('wlsview=plansfirst')) {
                    wirelessDetails.experienceType = 'plansfirst';
                }
                else if (paramArry.includes('wlsview=devicesfirst')) {
                    wirelessDetails.experienceType = 'devicesfirst';
                }
                else if ((paramArry &&
                    paramArry.filter(function (param) { return (param.includes('handoffToken=') || param.includes('handofftoken=')); }).length > 0) ||
                    (wirelessDetailsInSM && wirelessDetailsInSM.handoffToken)) {
                    wirelessDetails.experienceType = 'onDevice';
                    if (wirelessDetailsInSM && wirelessDetailsInSM.handoffToken) {
                        wirelessDetails.handoffToken = wirelessDetailsInSM.handoffToken;
                    }
                    else {
                        var handoffToken = this.stateManager.get('appShell', 'handoffToken');
                        wirelessDetails.handoffToken = getUrlParamValue('handoffToken', handoffToken.url);
                    }
                }
            }
            else if (wirelessDetailsInSM && wirelessDetailsInSM.experienceType) {
                wirelessDetails.experienceType = wirelessDetailsInSM.experienceType;
                if (wirelessDetailsInSM.handoffToken) {
                    wirelessDetails.handoffToken = wirelessDetailsInSM.handoffToken;
                }
            }
            this.stateManager.set('wirelessDetails', __assign({}, wirelessDetails));
        }
    };
    MainViewContainer.prototype.setURLInState = function () {
        var url = location.href;
        if (url.indexOf('/buy') > -1) {
            var arrURL = url.split('/buy');
            if (arrURL.length > 1) {
                this.stateManager.set('baseURL', { url: arrURL[1] });
            }
            if (this.props.bundleType === CatalogDataType.Offers) {
                this.stateManager.set('baseURLWLS', { url: '/offers/changerateplan' });
            }
            else if (this.props.bundleType === CatalogDataType.Broadband) {
                this.stateManager.set('baseURLBB', { url: '/broadband' });
            }
            else {
                this.stateManager.set('baseURLWLS', { url: '/wireless' });
            }
        }
    };
    MainViewContainer.prototype.loadOffers = function (bundleType) {
        var _this = this;
        switch (bundleType) {
            case CatalogDataType.DTVNOW:
                checkAndSetZipCode();
                return this.loadDtvNowOffers();
            case CatalogDataType.Wireless:
                return this.loadWirelessOffers();
            case CatalogDataType.Offers:
                checkAndSetZipCode();
                var apiUrlOffers = void 0;
                var apiUrlBaseOffers = void 0;
                apiUrlOffers = this.passOfferInCatalogCall(baseURLOverall);
                apiUrlBaseOffers = baseURLDTVNOW;
                offersService.fetchData(apiUrlOffers).then(function (data) {
                    var errorObj = _this.catalogErrorHandling(data);
                    if (errorObj.isError) {
                        _this.actionOnError(errorObj);
                    }
                    else {
                        _this.stateManager.set('catalogResponse', data);
                    }
                    _this.setState({ loading: false });
                });
                return offersService.fetchData(apiUrlBaseOffers, CatalogDataType.Offers).then(function (data) {
                    var errorObj = _this.catalogErrorHandling(data);
                    if (errorObj.isError) {
                        // this.actionOnError(errorObj);
                    }
                    else {
                        _this.stateManager.set('crpCatalogResponse', data);
                        _this.stateManager.set('AppFlowCode', { flowcode: CatalogDataType.CrpPlanNew });
                    }
                });
            default:
                return Promise.reject('Not a valid URL.');
        }
    };
    MainViewContainer.prototype.componentWillMount = function () {
        updateDetails();
        routables.resetRoutableComponents();
        this.stateManager.set('AppFlowCode', { flowcode: this.props.bundleType });
        this.setState({ loading: true, lastPanelTheme: (this.props.bundleType === CatalogDataType.DTV) ? ThemeColor.DARK : ThemeColor.LIGHT });
        switch (this.props.bundleType) {
            case CatalogDataType.Broadband:
                this.setSentryTeam(SentryTeam.BROADBAND);
                break;
            default:
                this.setSentryTeam(SentryTeam.WIRELESS);
                break;
        }
        var flowCode = this.stateManager.get('WIRELESS', 'IDSEFlowSelected');
        var wlsIntent = getIDSEIntent();
        if ((wlsIntent && wlsIntent.toLowerCase() === 'new') ||
            (flowCode && flowCode.intent && flowCode.intent.toLowerCase() === 'dsnew')) {
            this.stateManager.set('IDSEIntent', { wirelessIntent: 'new' });
        }
        if (wlsIntent && wlsIntent.toLowerCase().search('al|aal|alf|up') > -1) {
            var wlsfi = getQueryParamValue('wlsfi');
            if (wlsfi && wlsfi.toLowerCase().search('al|aal|alf|up') > -1) {
                this.stateManager.remove('wlsAuthDetails');
                this.setState({
                    canLoadLobConsole: false,
                    loading: true,
                });
            }
            this.stateManager.set('IDSEIntent', { wirelessIntent: wlsIntent.toLowerCase() });
            var upperFunnelDetails = this.stateManager.get('appShell', this.upperFunnelDetailsSentToIDP) || {};
            // get the existing details and append the new details so that we do not loose the context
            // at any time
            if (getQueryParamValue(this.banKey) && getQueryParamValue(this.ctnKey)) {
                upperFunnelDetails[this.banKey] = getQueryParamValue(this.banKey);
                upperFunnelDetails[this.ctnKey] = getQueryParamValue(this.ctnKey);
                this.stateManager.set(this.upperFunnelDetailsSentToIDP, upperFunnelDetails);
            }
        }
        var skuIdFromUrl = getQueryParamValue('sku');
        if (skuIdFromUrl) {
            window.sessionStorage.setItem('WIRELESS:selectedDeviceSku', JSON.stringify({ sku: skuIdFromUrl }));
        }
        var editLinkUrl = this.stateManager.get('CART', 'editLinkUrl');
        var redirectTo = getQueryParamValue('redirectTo');
        if (!editLinkUrl && redirectTo && redirectTo.toUpperCase() === 'CART') {
            this.redirectToCart = 'true';
        }
        if (redirectTo && redirectTo.toUpperCase() !== 'CART') {
            this.redirectToCart = 'false';
        }
    };
    MainViewContainer.prototype.componentWillUnmount = function () {
        this.unregisterEvents();
        routables.resetRoutableComponents();
    };
    MainViewContainer.prototype.componentDidMount = function () {
        var _this = this;
        offersService.setCSRFToken().then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var token, sessionId, sessionIdVal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = { value: res.headers.get('X-CSRF-TOKEN') };
                        sessionId = { value: res.headers.get('sid') };
                        sessionIdVal = '';
                        if (sessionId && sessionId.value) {
                            this.stateManager.set('sid', sessionId);
                            sessionIdVal = sessionId.value;
                        }
                        if (token.value !== null) {
                            this.stateManager.set('csrf-token', token);
                        }
                        this.halocAuthService = new HalocAuthenticationService();
                        return [4 /*yield*/, this.halocAuthService.checkHalocAuth('sales')];
                    case 1:
                        _a.sent();
                        this.registerEvents();
                        Promise.all([
                            this.featureToggleCall(this.featureConfigObj),
                            this.getCmsRoute(this.props.bundleType),
                        ])
                            .then(function () {
                            _this.setState({ allowCMSGetCall: true });
                        })
                            .catch(function (err) {
                            logToSplunkwithExtraDetails(err, {
                                url: 'Core-ui:Methods: featureToggleCall and getCmsRoute',
                                apiName: 'IDP_Log Failed on parallel call to IXP flags and CMS feed',
                            });
                        });
                        this.initializeCart(sessionIdVal);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    // tslint:disable-next-line:no-any
    MainViewContainer.prototype.componentDidCatch = function (error, info) {
        // Log the error details to splunk
        logToSplunk({ data: CatalogErrorMsgCms.content.errorDefaultMsg.message });
        logToSplunk({ data: JSON.stringify({ details: info.componentStack, trace: error.stack }) });
    };
    MainViewContainer.prototype.callLoadOffersForLobs = function () {
        var _this = this;
        if (!(this.props.bundleType === CatalogDataType.DTV
            || this.props.bundleType === CatalogDataType.Broadband
            || this.props.bundleType === CatalogDataType.IPTV
            || this.props.bundleType === CatalogDataType.Bundle)) {
            this.loadOffers(this.props.bundleType)
                .catch(function (res) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
                console.log("loadOffers err", res, res === null || res === void 0 ? void 0 : res.error);
                if (((_a = res === null || res === void 0 ? void 0 : res.error) === null || _a === void 0 ? void 0 : _a.errorId) === CTOErrorCodes.BUSINESS_AUTH_ERROR) {
                    var error = {
                        apiName: '',
                        errorCode: (_b = res === null || res === void 0 ? void 0 : res.error) === null || _b === void 0 ? void 0 : _b.errorId,
                        message: (_d = (_c = _this.apiCTOModalCmsData) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.callMsg,
                        title: (_f = (_e = _this.apiCTOModalCmsData) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.heading,
                        redirectURL: !!((_g = res === null || res === void 0 ? void 0 : res.error) === null || _g === void 0 ? void 0 : _g.details) && !!((_h = res.error.details[0]) === null || _h === void 0 ? void 0 : _h.code) && !!res.error.details[0].message
                            && res.error.details[0].code == 'redirectUrl' ? res.error.details[0].message : '',
                    };
                    _this.showErrorModal(error);
                }
                else if (((_j = res === null || res === void 0 ? void 0 : res.error) === null || _j === void 0 ? void 0 : _j.errorId) === CTOErrorCodes.WLS_TKN_001) {
                    var error = {
                        apiName: '',
                        errorCode: (_k = res === null || res === void 0 ? void 0 : res.error) === null || _k === void 0 ? void 0 : _k.errorId,
                        message: (_m = (_l = _this.apiCTOModalCmsData) === null || _l === void 0 ? void 0 : _l.content) === null || _m === void 0 ? void 0 : _m.callMsg,
                        title: (_p = (_o = _this.apiCTOModalCmsData) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p.heading,
                        redirectURL: !!((_q = res === null || res === void 0 ? void 0 : res.error) === null || _q === void 0 ? void 0 : _q.details) && !!((_r = res.error.details[0]) === null || _r === void 0 ? void 0 : _r.code) && !!res.error.details[0].message
                            && res.error.details[0].code == 'redirectUrl' ? res.error.details[0].message : ''
                    };
                    _this.showErrorModal(error);
                }
                else if (((_s = res === null || res === void 0 ? void 0 : res.error) === null || _s === void 0 ? void 0 : _s.errorId) === CTOErrorCodes.WLS_TKN_005) {
                    var error = {
                        apiName: '',
                        errorCode: (_t = res === null || res === void 0 ? void 0 : res.error) === null || _t === void 0 ? void 0 : _t.errorId,
                        message: (_v = (_u = _this.apiCTOModalCmsData) === null || _u === void 0 ? void 0 : _u.content) === null || _v === void 0 ? void 0 : _v.alreadyTwinnedMsg,
                        title: (_x = (_w = _this.apiCTOModalCmsData) === null || _w === void 0 ? void 0 : _w.content) === null || _x === void 0 ? void 0 : _x.alreadyTwinnedHeading,
                        redirectURL: !!((_y = res === null || res === void 0 ? void 0 : res.error) === null || _y === void 0 ? void 0 : _y.details) && !!((_z = res.error.details[0]) === null || _z === void 0 ? void 0 : _z.code) && !!res.error.details[0].message
                            && res.error.details[0].code == 'redirectUrl' ? res.error.details[0].message : ''
                    };
                    _this.showErrorModal(error);
                }
                else if (((_0 = res === null || res === void 0 ? void 0 : res.error) === null || _0 === void 0 ? void 0 : _0.errorId) === CTOErrorCodes.WLS_TKN_004) {
                    var error = {
                        apiName: '',
                        errorCode: (_1 = res === null || res === void 0 ? void 0 : res.error) === null || _1 === void 0 ? void 0 : _1.errorId,
                        message: (_3 = (_2 = _this.apiCTOModalCmsData) === null || _2 === void 0 ? void 0 : _2.content) === null || _3 === void 0 ? void 0 : _3.ctnValidationMsg,
                        title: (_5 = (_4 = _this.apiCTOModalCmsData) === null || _4 === void 0 ? void 0 : _4.content) === null || _5 === void 0 ? void 0 : _5.ctnValidationHeading,
                        redirectURL: !!((_6 = res === null || res === void 0 ? void 0 : res.error) === null || _6 === void 0 ? void 0 : _6.details) && !!((_7 = res.error.details[0]) === null || _7 === void 0 ? void 0 : _7.code) && !!res.error.details[0].message
                            && res.error.details[0].code == 'redirectUrl' ? res.error.details[0].message : ''
                    };
                    _this.showErrorModal(error);
                }
                else if (((_8 = res === null || res === void 0 ? void 0 : res.error) === null || _8 === void 0 ? void 0 : _8.errorId) === CTOErrorCodes.SYSTEM_AUTH_ERROR || (res === null || res === void 0 ? void 0 : res.status) === 500) {
                    var message = ((_9 = res === null || res === void 0 ? void 0 : res.url) === null || _9 === void 0 ? void 0 : _9.includes('ordersrc')) ? (_11 = (_10 = _this.apiCTOModalCmsData) === null || _10 === void 0 ? void 0 : _10.content) === null || _11 === void 0 ? void 0 : _11.ctnMsg : (_13 = (_12 = _this.apiCTOModalCmsData) === null || _12 === void 0 ? void 0 : _12.content) === null || _13 === void 0 ? void 0 : _13.waitMsg;
                    var error = {
                        apiName: '',
                        errorCode: (_14 = res === null || res === void 0 ? void 0 : res.error) === null || _14 === void 0 ? void 0 : _14.errorId,
                        message: message,
                        title: (_16 = (_15 = _this.apiCTOModalCmsData) === null || _15 === void 0 ? void 0 : _15.content) === null || _16 === void 0 ? void 0 : _16.heading,
                        redirectURL: !!((_17 = res === null || res === void 0 ? void 0 : res.error) === null || _17 === void 0 ? void 0 : _17.details) && !!((_18 = res.error.details[0]) === null || _18 === void 0 ? void 0 : _18.code) && !!res.error.details[0].message
                            && res.error.details[0].code == 'redirectUrl' ? res.error.details[0].message : ''
                    };
                    _this.showErrorModal(error);
                }
                else {
                    var error = __assign({ apiName: '', errorCode: '' }, CatalogErrorMsgCms.content.errorDefaultMsg);
                    _this.showErrorModal(error);
                }
            });
            this.getNewCartPrice();
        }
        else {
            this.setState({ loading: false });
        }
        var baseURL = this.props.baseURL ? this.props.baseURL.url : '';
        // updated the condition so that the baseURL is set when we already have 1 variant of the base url
        if ((baseURL === null || baseURL === undefined) && (location.href.includes(baseURL))) {
            this.setURLInState();
        }
    };
    MainViewContainer.prototype.getNewCartPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    offersService.fetchData(priceInfoUrl).then(function (data) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        var initialPrice = data;
                        if (initialPrice && (initialPrice.error ||
                            (initialPrice.content && initialPrice.content.status !== 'success'))) {
                            return;
                        }
                        var cartState = initialPrice && initialPrice.content;
                        if ((!((_b = (_a = cartState === null || cartState === void 0 ? void 0 : cartState.payload) === null || _a === void 0 ? void 0 : _a.priceInfo) === null || _b === void 0 ? void 0 : _b.dtvnowPriceInfo) ||
                            (((_e = (_d = (_c = cartState === null || cartState === void 0 ? void 0 : cartState.payload) === null || _c === void 0 ? void 0 : _c.priceInfo) === null || _d === void 0 ? void 0 : _d.dtvnowPriceInfo) === null || _e === void 0 ? void 0 : _e.dueToday) === 0 && ((_h = (_g = (_f = cartState === null || cartState === void 0 ? void 0 : cartState.payload) === null || _f === void 0 ? void 0 : _f.priceInfo) === null || _g === void 0 ? void 0 : _g.dtvnowPriceInfo) === null || _h === void 0 ? void 0 : _h.dueMonthly) === 0))) {
                            var newdata = {
                                dueMonthly: 0,
                                dueToday: 0,
                                readyToCheckout: false,
                            };
                            _this.stateManager.set('ClearLobData', newdata);
                            _this.stateManager.set('priceBarUpdate', newdata);
                        }
                    });
                }
                catch (error) {
                    console.error("error retrieving initial price: " + error);
                }
                return [2 /*return*/];
            });
        });
    };
    MainViewContainer.prototype.getMainContent = function () {
        var _this = this;
        var title = titleMap
            && titleMap.get(this.props.bundleType) ? titleMap.get(this.props.bundleType) : '';
        document.title = '' + title;
        var intent = 'sales-wireless';
        if (this.state.dataToOrchestrateLogin && this.state.dataToOrchestrateLogin.data.intent) {
            intent = this.state.dataToOrchestrateLogin.data.intent;
        }
        if (this.state.dataToOrchestrateLogin && this.state.dataToOrchestrateLogin.displayLogin) {
            return (React.createElement(LoginOrchestration, { data: { intent: intent }, events: {
                    isAuthenticated: function (authenticated, cancelled) {
                        _this.LoginOrchestrationCallBack(authenticated, cancelled, intent);
                    },
                } }));
        }
        if (this.state.canLoadLobConsole) {
            switch (this.props.bundleType) {
                case CatalogDataType.Broadband:
                    return React.createElement(Broadband, null);
                case CatalogDataType.Bundle:
                    return React.createElement(Wireless, null);
            }
        }
    };
    MainViewContainer.prototype.reportAppShellPageLoad = function () {
        // System event for Cart SUmmary
        var addData = {
            additionalData: {
                url: location.pathname + location.search,
            },
            eventAction: 'pageLoad',
            eventCode: 'Page_Load',
        };
        ReportingGateway.sendReportingEvent(addData);
    };
    MainViewContainer.prototype.handleOKButton = function () {
        var _a;
        if (!!((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.redirectURL)) {
            window.location.href = this.state.error.redirectURL;
            return;
        }
        var baseURL = this.stateManager.get('appShell', 'baseURL');
        var prefix = baseURL && baseURL.url.indexOf('/prepaid') > -1 ? '/buy/wireless/prepaid/' : '/buy/wireless/';
        var addData = {
            additionalData: {
                linkDestinationUrl: prefix + 'cto/modal',
                linkName: this.props.bundleType.toUpperCase() === CatalogDataType.Wireless.toUpperCase() ? 'Close' : "Let's chat",
                linkPosition: LinkPositionDataKeysOptions.HEADER,
            },
            eventAction: EventActions.LINK_CLICK,
            eventCode: 'Link_Click',
        };
        if (addData && this.props.bundleType.toUpperCase() === CatalogDataType.Wireless.toUpperCase()) {
            ReportingGateway.sendReportingEvent(addData);
        }
        var curUrl = window.location.href;
        if (curUrl.includes('buy/wireless')) {
            try {
                Inq.fireCustomEvent('FirePro');
            }
            catch (err) {
                window.location.href = 'https://www.att.com';
            }
        }
        else {
            window.location.href = 'https://help.directvnow.com/hc/en-us/articles/210968526';
        }
    };
    MainViewContainer.prototype.handleCancelButton = function () {
        // console.log('Cancel Clicked');
    };
    MainViewContainer.prototype.findEapState = function () {
        var wirelessDetails = this.stateManager.get('appShell', 'wirelessDetails');
        var eapInCart = this.stateManager.get('WIRELESS', 'eapInCart');
        var isEapOnDevice = wirelessDetails && wirelessDetails.experienceType === 'onDevice';
        var isEapOffDevice = eapInCart && eapInCart.eapFlow &&
            eapInCart.eapFlow.search('eapInCart') > -1;
        return { isEapOffDevice: isEapOffDevice, isEapOnDevice: isEapOnDevice };
    };
    MainViewContainer.prototype.showErrorModal = function (error) {
        logToSplunk({ data: (error.title + ':' + error.message) });
        Sentry.captureMessage(JSON.stringify(error));
        if (this.props.bundleType === CatalogDataType.Wireless) {
            var eapState = this.findEapState();
            if (eapState && eapState.isEapOnDevice) {
                this.setState({ canLoadLobConsole: true, loading: false });
                window.sessionStorage.setItem('WIRELESS:hardStopPage', JSON.stringify({ hardStopPageCTO: true }));
                this.displayHardStopPage = true;
            }
            else {
                this.setState({ error: error });
                this.pageLoadForErrorModal();
            }
        }
        else {
            this.setState({ error: error });
            this.pageLoadForErrorModal();
        }
    };
    MainViewContainer.prototype.pageLoadForErrorModal = function () {
        var baseURL = this.stateManager.get('appShell', 'baseURL');
        var prefix = baseURL && baseURL.url.indexOf('/prepaid') > -1 ? '/buy/wireless/prepaid/' : '/buy/wireless/';
        var eapState = this.findEapState();
        var addData = {
            additionalData: {
                url: prefix + 'cto/modal',
            },
            eventAction: EventActions.PAGE_LOAD,
            eventCode: 'Page_Load',
        };
        if (addData && this.props.bundleType.toUpperCase() === CatalogDataType.Wireless.toUpperCase()) {
            if (getIDSEIntent().search('al|aal|alf') > -1) {
                if (eapState && eapState.isEapOffDevice) {
                    addData.additionalData['page.pageInfo.flowCode'] = 'EAAL';
                    addData.additionalData['page.attributes.productType'] = 'EAP Postpaid Coam';
                }
                else {
                    addData.additionalData['page.pageInfo.flowCode'] = 'DSAAL';
                    addData.additionalData['page.attributes.productType'] = 'Postpaid';
                }
            }
            else if (getIDSEIntent() === 'up') {
                addData.additionalData['page.pageInfo.flowCode'] = 'DSUP';
                addData.additionalData['page.attributes.productType'] = 'Postpaid';
            }
            else {
                addData.additionalData['page.pageInfo.flowCode'] = 'DSUNK';
                addData.additionalData['page.attributes.productType'] = 'Postpaid';
            }
            addData.additionalData['page.pageInfo.lineOfBusiness'] = 'Wireless';
            addData.additionalData['page.category.pageGroup'] = 'SALES',
                ReportingGateway.sendReportingEvent(addData);
        }
    };
    MainViewContainer.prototype.catalogErrorHandling = function (data) {
        var errorObj = {
            errorCode: '0000',
            isError: false,
        };
        if (data !== null && data !== undefined && data.error !== undefined) {
            if (data.error.errorId !== null && data.error.errorId !== undefined) {
                var errorCode = data.error.errorId.toUpperCase();
                if (errorCode === 'CTLG_E400009' || errorCode === 'CTLG_E400004') {
                    window.location.href = 'https://www.directvnow.com/';
                }
                if (errorCode === 'CATLG-VAL-ERROR-10001') {
                    window.location.href = '/buy/dtvnow';
                }
                errorObj.isError = true;
                errorObj.errorCode = errorCode;
            }
        }
        return errorObj;
    };
    MainViewContainer.prototype.actionOnError = function (errorObj) {
        if (errorObj && errorObj.isError) {
            if (errorObj.errorCode === 'CTLG_E400009' || errorObj.errorCode === 'CTLG_E400004') {
                window.location.href = CatalogErrorMsgCms.content.CTLG_E400009.action;
            }
            else if (errorObj && errorObj.isError && errorObj.errorCode === 'CTLG-E400014') {
                //show hardstop page if account is not supporting 
                // mutiple groups, AAL STC flow
                window.sessionStorage.setItem('WIRELESS:hardStopPage', JSON.stringify({ hardStopPageCTO: true }));
                this.setState({
                    loading: false
                });
                this.displayHardStopPage = true;
            }
            else {
                var error = {
                    apiName: '',
                    errorCode: '',
                    message: CatalogErrorMsgCms.content.errorDefaultMsg.message,
                    title: CatalogErrorMsgCms.content.errorDefaultMsg.title,
                };
                this.showErrorModal(error);
            }
        }
    };
    MainViewContainer.prototype.checkOffersInUrl = function () {
        var query = location.href;
        var offerObj = {
            isOffer: false,
            offerUrlVal: '',
            strMatch: '/offers',
        };
        if (query.includes(offerObj.strMatch)) {
            offerObj.isOffer = true;
            var arry = query.split(offerObj.strMatch);
            if (arry[1].length >= 1) {
                if (arry[1].indexOf('offerID=') > -1) {
                    offerObj.offerUrlVal = '/' + arry[1].split('offerID=')[1];
                }
                else {
                    offerObj.offerUrlVal = arry[1];
                }
                // added for refresh scenarios
                this.stateManager.set('offerId', { offer: offerObj.offerUrlVal });
            }
            return offerObj;
        }
        else {
            return offerObj;
        }
    };
    MainViewContainer.prototype.passOfferInCatalogCall = function (apiUrl) {
        var offerId = this.props.offerId;
        if (offerId !== null && offerId !== undefined) {
            return apiUrl + offerId.offer;
        }
        else {
            var offerObj = this.checkOffersInUrl();
            if (offerObj.isOffer) {
                var urlVal = apiUrl.split(offerObj.strMatch);
                var catalogApiUrl = apiUrl + offerObj.offerUrlVal;
                return catalogApiUrl;
            }
            else {
                return apiUrl;
            }
        }
    };
    MainViewContainer.prototype.unregisterEvents = function () {
        ICCEventBusManager.getInstance().deregisterObserver(this.observerId);
    };
    MainViewContainer.prototype.registerEvents = function () {
        var _this = this;
        this.observerId = ICCEventBusManager.getUUID();
        var iptvObserver = {
            eventHandler: function () { _this.iptvListener(); },
            observerId: this.observerId,
            serviceName: 'DTVNOW:iptvMigrationIntent',
        };
        ICCEventBusManager.getInstance().registerObserver(iptvObserver);
        var crpObserver = {
            eventHandler: function () { _this.crpChangeListener('WIRELESS'); },
            observerId: this.observerId,
            serviceName: 'WIRELESS:changeRatePlanEvent',
        };
        ICCEventBusManager.getInstance().registerObserver(crpObserver);
        var baseURLObserver = {
            eventHandler: function () { _this.firePageLoadEvent(); },
            observerId: this.observerId,
            serviceName: 'appShell:baseURL',
        };
        ICCEventBusManager.getInstance().registerObserver(baseURLObserver);
        // Observer for feature toggle
        var featureToggleObserver = {
            eventHandler: function () { _this.featureToggleSwitcher(); },
            observerId: this.observerId,
            serviceName: 'appShell:featureToggleStatus',
        };
        ICCEventBusManager.getInstance().registerObserver(featureToggleObserver);
        var dtvsLoginConsoleConfig = {
            eventHandler: function () { return _this.orchestrateToLogin('DTVS'); },
            observerId: this.observerId,
            serviceName: "DTVS:loginConsole",
        };
        ICCEventBusManager.getInstance().registerObserver(dtvsLoginConsoleConfig);
        var broadbandLoginConsoleConfig = {
            eventHandler: function () { return _this.orchestrateToLogin('Broadband'); },
            observerId: this.observerId,
            serviceName: "Broadband:loginConsole",
        };
        ICCEventBusManager.getInstance().registerObserver(broadbandLoginConsoleConfig);
        var wlsLoginConsoleConfig = {
            eventHandler: function () { return _this.orchestrateToLogin('WIRELESS'); },
            observerId: this.observerId,
            serviceName: "WIRELESS:loginConsole",
        };
        ICCEventBusManager.getInstance().registerObserver(wlsLoginConsoleConfig);
        var bundleLoginConsoleConfig = {
            eventHandler: function () { return _this.orchestrateToLogin('Bundles'); },
            observerId: this.observerId,
            serviceName: "Bundles:loginConsole",
        };
        ICCEventBusManager.getInstance().registerObserver(bundleLoginConsoleConfig);
        // Added observer for DTVSPromoType for Personalization
        var dtvsPersonlizationP13N = {
            eventHandler: function () { return _this.getDtvsPersonalzationParamter('DTVS', CatalogDataType.DTV); },
            observerId: this.observerId,
            serviceName: "DTVS:P13N",
        };
        ICCEventBusManager.getInstance().registerObserver(dtvsPersonlizationP13N);
    };
    MainViewContainer.prototype.crpChangeListener = function (lob) {
        var crpObj = this.stateManager.get(lob, 'changeRatePlanEvent');
        if (crpObj.actionType === 'existingPlanSelected') {
            this.stateManager.set('planSelected', { plan: 'existing' });
        }
        if (crpObj.actionType === 'newPlanSelected') {
            this.stateManager.set('planSelected', { plan: 'new' });
        }
    };
    MainViewContainer.prototype.featureToggleSwitcher = function () {
        // tslint:disable-next-line:no-any
        var featureToggleData = this.stateManager.get('appShell', 'featureToggleStatus');
        this.setState({ featureToggleStatusData: featureToggleData });
    };
    MainViewContainer.prototype.iptvListener = function () {
        var _this = this;
        var crpObj = this.stateManager.get('DTVNOW', 'iptvMigrationIntent');
        if (crpObj.intent) {
            this.loadOffers(CatalogDataType.DTVNOW)
                .catch(function () {
                var error = __assign({ apiName: '', errorCode: '' }, CatalogErrorMsgCms.content.errorDefaultMsg);
                _this.showErrorModal(error);
            });
        }
        else {
            // make a call to false
        }
    };
    MainViewContainer.prototype.getAppData = function () {
        var canvasContentStyleWrapper = this.props.bundleType === CatalogDataType.Bundle ? styles.canvasContentStyleBundles : '';
        return (React.createElement("div", { className: canvasContentStyleWrapper },
            React.createElement(BannerContainer, { bundleType: this.props.bundleType }),
            this.getMainContent()));
    };
    MainViewContainer.prototype.initQueueIt = function () {
        if (this.state.featureToggleStatusData && this.state.featureToggleStatusData.allocations
            && this.state.featureToggleStatusData.allocations['svc-pcv1-queue-it']) {
            if (this.state.featureToggleStatusData.allocations['svc-pcv1-queue-it'].value === 'true') {
                var isProd = (/(www.att.com|m.att.com)/i).test(location.hostname.toLowerCase());
                var script1 = document.createElement('script');
                script1.type = 'text/javascript';
                script1.src = '//static.queue-it.net/script/queueclient.min.js';
                document.body.appendChild(script1);
                var script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.src = '//static.queue-it.net/script/queueconfigloader.min.js';
                script2.setAttribute('data-queueit-c', isProd ? 'attcom' : 'attcomtest');
                document.body.appendChild(script2);
            }
        }
    };
    MainViewContainer.prototype.loadSessionTimerPing = function () {
        var dataString = "<source id=\"src_mp3\" type=\"audio/mp3\" src={'/buy/quiet.01.mp3'} />\n            <source id=\"src_ogg\" type=\"audio/ogg\" src={'/buy/quiet.01.ogg'} />\n            <object id=\"audio_object\" type=\"audio/x-mpeg\" width=\"200px\" height=\"45px\" data={'/buy/quiet.01.mp3'} >\n                <param id=\"param_src\" name=\"src\" value={'/buy/quiet.01.mp3'} />\n                <param name=\"autoplay\" value=\"false\" />\n                <param name=\"autostart\" value=\"false\" />\n            </object>";
        if (isMobile) {
            return dataString;
        }
        else
            return '';
    };
    MainViewContainer.prototype.render = function () {
        var noDisplay = {
            display: 'none',
        };
        if (!this.displayHardStopPage &&
            this.state.error && this.state.error.title && this.state.error.message) {
            var errorCode = this.state.error.errorCode;
            var sEntry = {
                apiError: {
                    apiName: this.state.error.apiName || '',
                    errorCode: errorCode || '',
                },
                cmsErrorCodes: this.state.errorCodes || [{
                        apiName: '',
                        errorCode: '',
                        errorMsg: '',
                    }],
            };
            var btnText = (errorCode === CTOErrorCodes.WLS_TKN_005 || errorCode === CTOErrorCodes.WLS_TKN_004) ? "Start over" : "Close";
            var options = {
                customErrorMsg: this.state.error.message,
                modalTitle: this.state.error.title,
                okBtnText: (this.props.bundleType.toUpperCase() === CatalogDataType.Wireless.toUpperCase()) ? btnText : "Let's chat",
            };
            return (React.createElement(CustomErrMsgDialog, { dialogServiceRef: this.dialog, options: options, events: { okCTA: this.handleOKButton, closeCTA: this.handleCancelButton }, data: sEntry }));
        }
        if (this.state.loading) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null, "Loading..."),
                React.createElement("div", { className: styles.infiniteLoaderWrapper },
                    React.createElement(InfiniteLoader, null))));
        }
        var appendSlash = location.pathname.endsWith('/wireless') || location.pathname.endsWith('/wireless/');
        return (React.createElement(RoutableContainer, { appendSlashInInitialRoute: appendSlash },
            React.createElement("audio", { id: "audio_player", style: noDisplay }, this.loadSessionTimerPing()),
            React.createElement(SessionTimerModal, { data: { redirectURL: this.getRedirectURL() } }),
            this.state.allowCMSGetCall ?
                this.getAppData() : React.createElement("div", { style: { height: 500 } })));
    };
    MainViewContainer.prototype.callSessionCreationAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, offersService.fetchData(createSalesSessionAPI).then(function (data) {
                        // console.log('data', data);
                    })];
            });
        });
    };
    MainViewContainer.prototype.getRedirectURL = function () {
        var baseURL = this.stateManager.get('appShell', 'baseURL');
        var redirectUrl = baseURL && baseURL.url ? '/buy' + baseURL.url : '/';
        return redirectUrl;
    };
    /* Porting Page Events - Starts */
    MainViewContainer.prototype.firePageLoadEvent = function () {
        if (!(location.href.indexOf('buy/cart') > -1) && !(location.href.indexOf('buy/bundles') > -1) && !(location.href.indexOf('buy/checkout') > -1)) {
            var baseURL = this.stateManager.get('appShell', 'baseURL');
            var selectedDeviceConfigFromPLP = window.sessionStorage.getItem('selectedDeviceConfig');
            var addData = null;
            if (baseURL && !(baseURL.url.indexOf('/prepaid') > -1)) {
                addData = {
                    additionalData: {
                        url: this.getCurrentURL(this.props.bundleType),
                    },
                    eventAction: EventActions.PAGE_LOAD,
                    eventCode: 'Page_Load',
                };
            }
            if (addData && baseURL && (baseURL.url.indexOf('/prepaid') > -1)) {
                addData.additionalData['page.pageInfo.flowCode'] = 'DSPREPAID';
                addData.additionalData['page.attributes.productType'] = 'Prepaid';
                addData.additionalData['page.pageInfo.lineOfBusiness'] = 'Wireless';
                if (baseURL.url.indexOf('?wlsview=plansfirst') > -1) {
                    addData.additionalData['page.pageInfo.pathingIntent'] = 'Plans First';
                }
                if (baseURL.url.indexOf('?wlsview=devicesfirst') > -1) {
                    addData.additionalData['page.pageInfo.pathingIntent'] = 'Devices First';
                }
                ReportingGateway.sendReportingEvent(addData);
                this.pageLoadEventTriggered = true;
            }
            else if (addData && this.props.bundleType.toUpperCase() === CatalogDataType.Wireless.toUpperCase() &&
                baseURL && baseURL.url && this.isPageLoadEvenetNeeded(baseURL) && !selectedDeviceConfigFromPLP) {
                if (getIDSEIntent().search('al|aal|alf') > -1) {
                    addData.additionalData['page.pageInfo.flowCode'] = 'DSAAL';
                    addData.additionalData['page.attributes.productType'] = 'Postpaid';
                    addData.additionalData['page.pageInfo.pathingIntent'] = 'AAL';
                }
                else if (getIDSEIntent() === 'up') {
                    addData.additionalData['page.pageInfo.flowCode'] = 'DSUP';
                    addData.additionalData['page.attributes.productType'] = 'Postpaid';
                    addData.additionalData['page.pageInfo.pathingIntent'] = 'Upgrade';
                }
                else if (getIDSEIntent() === 'new') {
                    addData.additionalData['page.pageInfo.flowCode'] = 'DSNEW';
                    addData.additionalData['page.attributes.productType'] = 'Postpaid';
                }
                else {
                    addData.additionalData['page.pageInfo.flowCode'] = 'DSUNK';
                    addData.additionalData['page.attributes.productType'] = 'Postpaid';
                }
                addData.additionalData['page.pageInfo.lineOfBusiness'] = 'Wireless';
                ReportingGateway.sendReportingEvent(addData);
                this.pageLoadEventTriggered = true;
            }
            else if (!this.pageLoadEventTriggered && baseURL && !(baseURL.url.indexOf('/wireless') > -1)) {
                ReportingGateway.sendReportingEvent(addData);
                this.pageLoadEventTriggered = true;
            }
        }
    };
    MainViewContainer.prototype.isPageLoadEvenetNeeded = function (baseURL) {
        var wirelessIntent = getIDSEIntent();
        return baseURL && baseURL.url && (baseURL.url === '/wireless' || baseURL.url === '/wireless/') && (wirelessIntent === '' || isNullOrUndefined(wirelessIntent));
    };
    MainViewContainer.prototype.getCurrentURL = function (bundleType) {
        var currentUrl = loadedPanelURL.get(bundleType);
        return currentUrl;
    };
    /* Porting Page Events - Ends */
    MainViewContainer.prototype.initializeCart = function (sessionIdVal) {
        var _this = this;
        console.log('calling init cart api');
        // this.setState({ allowCMSGetCall: true });
        if (!this.isLob('/prepaid') && getIDSEIntent().search('al|aal|alf') === -1) {
            new InitializeCart().initializeCartApi('appShell:csrf-token', sessionIdVal)
                .then(function (res) { return res.json(); })
                .then(function (data) { _this.callLoadOffersForLobs(); if (data) {
                _this.stateManager.set('initializeCartResp', data);
            } })
                .catch(function () { _this.callLoadOffersForLobs(); });
        }
        else {
            this.callLoadOffersForLobs();
        }
    };
    MainViewContainer.prototype.orchestrateToLogin = function (lob) {
        var dataToOrchestrateLogin = this.stateManager.get(lob, 'loginConsole');
        this.setState({ dataToOrchestrateLogin: dataToOrchestrateLogin });
    };
    MainViewContainer.prototype.LoginOrchestrationCallBack = function (authenticated, cancelled, intent) {
        var _this = this;
        this.stateManager.set('loginStatus', { authenticated: authenticated, cancelled: cancelled, intent: intent });
        this.setState({
            dataToOrchestrateLogin: {
                data: {
                    intent: intent,
                    topPanel: false,
                },
                displayLogin: false,
            },
        }, function () {
            var wlsIntent = getIDSEIntent();
            if (wlsIntent && wlsIntent.search('al|aal|alf|up') > -1) {
                _this.setState({ loading: true });
                _this.callLoadOffersForLobs();
            }
        });
    };
    MainViewContainer.prototype.loadLOBConsole = function () {
        this.setState({ loading: false, canLoadLobConsole: true });
        return Promise.resolve(this);
    };
    MainViewContainer.prototype.cartcall = function (response, intent) {
        var _this = this;
        if (response.content.validateCartResult && response.content.validateCartResult.cartExist) {
            var validCart = response.content.validateCartResult.validCart;
            var selectedDeviceConfig = window.sessionStorage.getItem('selectedDeviceConfig');
            if (selectedDeviceConfig) {
                validCart = false;
                window.sessionStorage.removeItem('WIRELESS:cartResponse');
            }
            var queryParam_1 = 'validCart=' + validCart + '&lob=wireless&wlsfi=' + intent;
            new InitializeCart().initializeCartWithAddlQueryParam(queryParam_1)
                .then(function (res) { return res.json(); })
                .then(function (data) {
                if (data && data.content && data.content.status.toLowerCase() === 'success' &&
                    data.content.payload && data.content.payload.wirelessCartStatus) {
                    if (_this.redirectToCart === 'true') {
                        window.location.href = '/buy/cart/';
                    }
                    else if (_this.redirectToCart === 'false') {
                        return _this.loadLOBConsole();
                    }
                    else if (_this.state.featureToggleStatusData && _this.state.featureToggleStatusData.allocations &&
                        _this.state.featureToggleStatusData.allocations['svc-pcv1-redirect-to-cart'] &&
                        _this.state.featureToggleStatusData.allocations['svc-pcv1-redirect-to-cart'].value === 'true') {
                        window.location.href = '/buy/cart/';
                    }
                    else {
                        return _this.loadLOBConsole();
                    }
                }
                else {
                    return _this.loadLOBConsole();
                }
            })
                .catch(function () {
                new InitializeCart().initializeCartWithAddlQueryParam(queryParam_1)
                    .then(function (res) { return res.json(); })
                    .then(function (data) {
                    if (data && data.content && data.content.status.toLowerCase() === 'success' &&
                        data.content.payload && data.content.payload.wirelessCartStatus) {
                        if (_this.redirectToCart === 'true') {
                            window.location.href = '/buy/cart/';
                        }
                        else if (_this.redirectToCart === 'false') {
                            return _this.loadLOBConsole();
                        }
                        else if (_this.state.featureToggleStatusData && _this.state.featureToggleStatusData.allocations &&
                            _this.state.featureToggleStatusData.allocations['svc-pcv1-redirect-to-cart'] &&
                            _this.state.featureToggleStatusData.allocations['svc-pcv1-redirect-to-cart'].value === 'true') {
                            window.location.href = '/buy/cart/';
                        }
                        else {
                            return _this.loadLOBConsole();
                        }
                    }
                    else {
                        return _this.loadLOBConsole();
                    }
                })
                    .catch(function () {
                    return _this.loadLOBConsole();
                });
            });
        }
        else if (response.content.upgradeEligibilityInfo) {
            return this.loadLOBConsole();
        }
        else {
            return Promise.reject(this);
        }
    };
    // tslint:disable-next-line:no-any
    MainViewContainer.prototype.processAuthResponse = function (offerUrl, intent, response) {
        var _this = this;
        if (response && response.content && response.content.eligibleForIDP) {
            this.loopCounter = 0;
            if (response && response.content && !response.content.stcFlow) {
                this.stateManager.set('wlsAuthDetails', response.content);
            }
            if (response.content.profileDetails && response.content.profileDetails.billingZipCode) {
                document.cookie = 'attPersistantLocalization=zip=' + response.content.profileDetails.billingZipCode + ';path=/';
            }
            if (intent === 'up') {
                if (response && response.content && response.content.stcFlow) {
                    var upperFunnelDetails = this.stateManager.get('appShell', this.upperFunnelDetailsSentToIDP);
                    return offersService.fetchData("/msapi/upgradeoptions/v1/eligibility/account/?source=idp-online" + ((upperFunnelDetails === null || upperFunnelDetails === void 0 ? void 0 : upperFunnelDetails.selectedCTNforUpgrade) ? '&selectedCTNforUpgrade=' + (upperFunnelDetails === null || upperFunnelDetails === void 0 ? void 0 : upperFunnelDetails.selectedCTNforUpgrade) : '')).then(function (data) {
                        if (data.content.upgradeEligibilityInfo) {
                            _this.stateManager.set('wlsAuthDetails', data.content);
                            return _this.cartcall(response, intent);
                        }
                        else {
                            return Promise.reject(data);
                        }
                    }).catch(function (res) {
                        logToSplunkwithExtraDetails(res, { url: '/msapi/upgrade-options/v1/eligibility/account', apiName: 'IDP_CTO_LOG Authentication Call Failure' });
                        _this.stateManager.remove('wlsAuthDetails');
                        _this.stateManager.remove('IDSEIntent');
                        _this.setState({ loading: false });
                        return Promise.reject(res);
                    });
                }
                else {
                    return this.cartcall(response, intent);
                }
            }
            else if (intent.search('al|aal|alf') > -1) {
                this.stateManager.set('wlsAuthDetails', response.content);
                offerUrl = this.constructdeiveListUrlwithAuthDetails(offerUrl);
                var windowUrl_1 = window.location.href;
                if (response.content.validateCartResult && response.content.validateCartResult.cartExist) {
                    var validCart = response.content.validateCartResult.validCart;
                    var selectedDeviceConfig = window.sessionStorage.getItem('selectedDeviceConfig');
                    var eapState = this.findEapState();
                    if (eapState.isEapOffDevice || eapState.isEapOnDevice || selectedDeviceConfig) {
                        validCart = false;
                        window.sessionStorage.removeItem('WIRELESS:cartResponse');
                    }
                    var queryParam_2 = 'validCart=' + validCart + '&lob=wireless&wlsfi=' + intent;
                    new InitializeCart().initializeCartWithAddlQueryParam(queryParam_2)
                        .then(function (res) { return res.json(); })
                        .then(function (data) {
                        var _a, _b, _c, _d;
                        if (((_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'success' && ((_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.wirelessCartStatus)) {
                            window.location.href = '/buy/cart/';
                        }
                        else {
                            var params = new URLSearchParams(windowUrl_1);
                            if (!!!params.get('ordersrc'))
                                _this.prepareWirelessOffers(offerUrl);
                            else
                                _this.setState({ loading: false, canLoadLobConsole: true });
                        }
                    })
                        .catch(function () {
                        new InitializeCart().initializeCartWithAddlQueryParam(queryParam_2)
                            .then(function (res) { return res.json(); })
                            .then(function (data) {
                            if (data && data.content && data.content.status.toLowerCase() === 'success' &&
                                data.content.payload && data.content.payload.wirelessCartStatus) {
                                window.location.href = '/buy/cart/';
                            }
                            else {
                                _this.prepareWirelessOffers(offerUrl);
                            }
                        })
                            .catch(function () {
                            _this.prepareWirelessOffers(offerUrl);
                        });
                    });
                }
                else {
                    this.prepareWirelessOffers(offerUrl);
                }
            }
            else {
                this.prepareWirelessOffers(offerUrl);
            }
        }
        else if (response && response.content && !response.content.eligibleForIDP && response.content.invokeLoginConsole) {
            // const redirectTo = getQueryParamValue('redirectTo');
            if (this.loopCounter === 3) {
                return this.redirectToZippyFlow(response);
            }
            else {
                this.loopCounter = this.loopCounter + 1;
                var redirectionIntent = sessionStorage.getItem('Wireless:AuthRedirectUrl');
                var url = "/buy/login?skipSave=true&skipAuth=false&skipCreate=true&redirectURL=wireless%2F";
                var redirectURL = "" + url + encodeURIComponent(redirectionIntent);
                // window.location.href = '/buy/login?skipSave=true&skipAuth=false&skipCreate=true&redirectURL=wireless%2F%3Fwlsfi%3D' + intent;
                window.location.href = redirectURL;
                return Promise.resolve(this);
            }
        }
        else if (response && response.content && !response.content.eligibleForIDP && !response.content.invokeLoginConsole) {
            return this.redirectToZippyFlow(response);
        }
        else if (response && response.error && response.error.errorId) {
            return Promise.reject(response);
        }
        else {
            return Promise.reject(this);
        }
    };
    // tslint:disable-next-line:no-any
    MainViewContainer.prototype.redirectToZippyFlow = function (response) {
        if (response && response.content && response.content.redirectionUrl) {
            this.stateManager.remove('wlsAuthDetails');
            this.stateManager.remove('IDSEIntent');
            window.location.href = response.content.redirectionUrl;
            return Promise.resolve(this);
        }
        else {
            return Promise.reject(this);
        }
    };
    // tslint:disable-next-line:no-any
    MainViewContainer.prototype.featureToggleCall = function (featureConfigObject) {
        var _this = this;
        var featureData = new FeatureState(featureConfigObject);
        // tslint:disable-next-line:no-any
        var featureVariable;
        featureVariable = featureData.getFeaturesState();
        featureVariable
            .then(function (res) {
            var respn = res.json();
            return respn;
        })
            .then(function (res) {
            _this.stateManager.set('featureToggleStatus', { allocations: res.allocations });
            setTimeout(function () {
                if (_this.state.featureToggleStatusData
                    && _this.state.featureToggleStatusData.allocations
                    && _this.state.featureToggleStatusData.allocations['svc-sentry-ena-001']) {
                    if (_this.state.featureToggleStatusData.allocations['svc-sentry-ena-001'].value === 'false') {
                        _this.initSentry();
                    }
                }
            });
        })
            .catch(function (error) {
            console.log('error ', error);
            logToSplunkwithExtraDetails(error, { url: 'featureToggleCall', apiName: 'IDP_LOG featureToggleCall failed' });
        });
    };
    return MainViewContainer;
}(React.Component));
export { MainViewContainer };
var mapStateToProps = function (state) {
    if (state && state.appShell) {
        return {
            baseURL: state.appShell.baseURL,
            catalogResponse: state.appShell.catalogResponse,
            offerId: state.appShell.offerId,
        };
    }
    return {};
};
var MainViewContainerWithStore = withStore(mapStateToProps)(MainViewContainer);
export default MainViewContainerWithStore;
//# sourceMappingURL=MainView.container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/MainView.container.js
// module id = 1416
// module chunks = 8